import { Injectable, signal } from '@angular/core';
import { HttpRequest, HttpErrorResponse } from '@angular/common/http';

export interface FailedRequestData {
    request: HttpRequest<any>;
    errorResponse: HttpErrorResponse;
}

@Injectable({ providedIn: 'root' })
export class FailedRequestService {
    // Section: STATE (SIGNALS, OBSERVABLES)
    //----------------------------------------------------------------------
    private readonly failedDataSignal = signal<FailedRequestData | null>(null);
    public failedData = this.failedDataSignal.asReadonly();

    // Section: PUBLIC METHODS
    //----------------------------------------------------------------------
    setFailedData(request: HttpRequest<any>, errorResponse: HttpErrorResponse): void {
        this.failedDataSignal.set({ request, errorResponse });
    }

    clear(): void {
        this.failedDataSignal.set(null);
    }
}
